import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_TIME_SECONDS_FORMAT,
} from 'src/app/core/ccomx-date-formats';
import { IAttachment } from 'src/app/shared/attachments/models/attachments.model';
import { MaintenanceJobTabReferrer } from 'src/app/maintenance-user/enums/maintenance-job-tab-referrer.enum';
import {
  isMaintenanceJobLogDateChange,
  maintenanceJobLogFieldTranslationKey,
} from 'src/app/maintenance-user/functions/maintenance-job-log-change.helpers';
import { getLinkToMaintenanceJobPerformDetails } from 'src/app/maintenance-user/functions/route-helpers';

@Component({
  selector: 'app-maintenance-job-log-template',
  templateUrl: './maintenance-job-log-template.component.html',
  styleUrls: ['./maintenance-job-log-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MaintenanceJobLogTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  dateFormat = DEFAULT_DATE_TIME_SECONDS_FORMAT;
  changeDateFormat = DEFAULT_DATE_FORMAT;
  logTabReferrer = MaintenanceJobTabReferrer.Log;
  getFieldLabelKey = maintenanceJobLogFieldTranslationKey;
  isDateChange = isMaintenanceJobLogDateChange;

  get legacyAttachment(): IAttachment | undefined {
    return this.element?.attachment ?? this.element?.legacyData;
  }

  getPerformViewRoute(): string {
    return getLinkToMaintenanceJobPerformDetails(
      this.element.componentId,
      this.element.jobId,
      this.element.id
    );
  }
}
